import React, { useState, useEffect } from "react";

const CustomToggleButton = ({ data, refreshList }) => {
  const [isActive, setIsActive] = useState(
    data.status === '1' || data.status === 1 || data.status === true
  );

  useEffect(() => {
    setIsActive(data.status === '1' || data.status === 1 || data.status === true);
  }, [data.status]);

  const handleToggle = async (e) => {
    const checked = e.target.checked;
    setIsActive(checked); // optimistic UI update

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/operator/status/${data.id}`,
        {
          method: "POST",
         headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
          body: JSON.stringify({ status: checked ? 1 : 0 }),
        }
      );

      if (!response.ok) throw new Error("Failed to update status");

      const result = await response.json();
      console.log("Status update success:", result);
      refreshList?.();
    } catch (error) {
      console.error("Status update failed:", error);
      setIsActive(!checked); // revert on error
    }
  };

  return (
    <>
      <label style={{ display: "inline-block", position: "relative", width: 50, height: 24 }}>
        <input
          type="checkbox"
          checked={isActive}
          onChange={handleToggle}
          style={{ opacity: 0, width: 0, height: 0 }}
          aria-label="Toggle operator status"
        />
        <span
          style={{
            position: "absolute",
            cursor: "pointer",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: isActive ? "#4caf50" : "#ccc",
            borderRadius: 24,
            transition: ".4s",
          }}
        />
        <span
          style={{
            position: "absolute",
            content: '""',
            height: 18,
            width: 18,
            left: isActive ? 26 : 4,
            bottom: 3,
            backgroundColor: "white",
            borderRadius: "50%",
            transition: ".4s",
          }}
        />
      </label>
    </>
  );
};

export default CustomToggleButton;
